module.exports = __webpack_public_path__ + "static/media/Knobs_Time_Left_Up.40eb6b10.png";